
// export const baseURL = `https://budi-api.vinratechllp.com/api/admin`
// export const imgBaseUrl = `https://budi-api.vinratechllp.com/api/admin` 
// export const baseURL = `https://budi-api-master.vinratechllp.com/api/admin`
export const baseURL = `https://apibuditravel.com/api/admin`
export const imgBaseUrl = `https://apibuditravel.com/api/admin`

